var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 1444,
    height: 1975
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Landing-/-Onboarding-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Onboarding---Register-Step-1-[D]",
    transform: "translate(-834.000000, -1024.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: 0,
    y: 0,
    width: 1440,
    height: 1684
  }), /*#__PURE__*/React.createElement("g", {
    id: "8.0-Modals-/-Register-[D]",
    transform: "translate(420.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "none",
    x: 0,
    y: 0,
    width: 600,
    height: 972,
    rx: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "4.0-Buttons-/-Primary-/-Invalid",
    transform: "translate(144.000000, 846.000000)",
    fill: "none",
    opacity: 0.299492972
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.0-Buttons-/-Primary"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,0 L267.257072,0 L296.358134,0 C298.567273,-4.05812251e-16 300.358134,1.790861 300.358134,4 L300.358134,40 C300.358134,42.209139 298.567273,44 296.358134,44 L4,44 C1.790861,44 2.705415e-16,42.209139 0,40 L0,4 C-7.1463071e-16,1.790861 1.790861,-3.82769592e-17 4,0 Z",
    id: "Rectangle"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-4.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "none"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "none",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "8.0-Modals-/-Register-[D]",
    transform: "translate(420.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "none",
    x: 0,
    y: 0,
    width: 600,
    height: 1240,
    rx: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Inputs",
    transform: "translate(150.000000, 195.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.0-Inputs-/-Input-Copy-7",
    transform: "translate(2.000000, 629.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Field",
    stroke: "#D9D9D9",
    x: 0.5,
    y: 6.5,
    width: 299,
    height: 47,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "3.0-Icons-/-Question-Mark",
    transform: "translate(262.000000, 18.000000)",
    fill: "#303030"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8013843,3.19861565 C16.0929645,2.92691843 16.5473409,2.93493538 16.829155,3.21674946 C17.110969,3.49856355 17.118986,3.95293992 16.8472888,4.24452007 L8.95367052,12 L16.8472888,19.7554799 C17.118986,20.0470601 17.110969,20.5014364 16.829155,20.7832505 C16.5473409,21.0650646 16.0929645,21.0730816 15.8013843,20.8013843 L7,12 L15.8013843,3.19861565 Z",
    id: "Shape",
    transform: "translate(12.022952, 12.000000) scale(-1, 1) rotate(270.000000) translate(-12.022952, -12.000000) "
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.1e18c61f679dbe0116167c9c7cc9359d.svg";
export { ForwardRef as ReactComponent };